import { createContext, useContext } from "react";

// Context that provides an optional MLO profile override for landing-page sections.
// null means we're on the root site (use static CONTACT defaults).
export const MLOContext = createContext(null);

export function useMLO() {
  return useContext(MLOContext);
}
